'use strict';
var Backbone = require('backbone');
var Radio = require('backbone.radio');
var polyglot = require('../utilities/polyglot').default;

var CancelView = require('../views/pages/cancel').default;
var WaitlistConfirmationView = require('../views/pages/waitlist-confirmation').default;

export default Backbone.Router.extend({

  initialize: function (options) {
    this.route('cancel', 'cancel');
    this.route(encodeURIComponent(polyglot.t('pages.waitlist_confirmation.slug')), 'waitlistConfirmation');
    this.layout = options.layout;
  },

  cancel: function () {
    Radio.channel('steps').trigger('off');
    Radio.channel('reschedule').trigger('set:here', false);
    this.layout.getRegion('main').show(new CancelView());
  },

  waitlistConfirmation: function () {
    Radio.channel('steps').trigger('off');
    Radio.channel('reschedule').trigger('set:here', false);
    this.layout.getRegion('main').show(new WaitlistConfirmationView({
      request: window.REQUEST,
    }));
  },
});
